    import Swiper from 'swiper';
    import { Navigation, Pagination } from 'swiper/modules';

    export default (Alpine) => {
        Alpine.data("productSpotlight", (variantId, discountCode) => ({
            swiper: null,
            variantId: variantId,
            discountCode: discountCode,
            activeIndex: 0,
            scrollY: 0,
            visible: false,

            init() {
                window.addEventListener('scroll', this.scrolling.bind(this));
                this.swiperInit()

            },

            scrolling() {
                console.log('scrolling');
                this.scrollY = this.$el.getBoundingClientRect().top;
            },

            swiperInit() {
                let self = this;
                this.swiper = new Swiper(this.$el.querySelector('.swiper'), {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    modules: [Navigation, Pagination],
                    pagination: {
                        el: this.$el.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    on: {
                        slideChange: function (e) {
                            console.log('slideChange', e);
                            self.activeIndex = e?.activeIndex;
                        },
                    },
                });
            },

            async getBundleIndex() {
                const res = await fetch('/cart.js');
                const cartData = await res.json();
            
                const indices = cartData.items
                .map(item => Number(item.properties?._dynamicBoxIndex))
                .filter(val => !isNaN(val));
            
                const largestIndex = indices.length > 0 ? Math.max(...indices) : -1;
                const bundleIndex = largestIndex + 1;
            
                return bundleIndex;
            },

            generateUniqueHash(length = 32) {
                const randomPart = Array.from(crypto.getRandomValues(new Uint8Array(length)))
                  .map(b => b.toString(16).padStart(2, '0'))
                  .join('');
                const timePart = Date.now().toString(16);
                return `${timePart}${randomPart}`;
            },

            async addToCart(isStack) {
                window.Rebuy.SmartCart.skip_open = false;

                const items = [];
              
                if (isStack) {
                  const stackProducts = window.stack_products || [];
                  const bundleIndex = await this.getBundleIndex();
                  const bundleSessionId = this.generateUniqueHash();
              
                  for (const product of stackProducts) {
                    const variant = product?.variants?.[0];
                    if (variant?.available) {
                      items.push({
                        id: variant.id,
                        quantity: 1,
                        selling_plan: null,
                        properties: {
                          _attribution: 'Skio Dynamic Product Bundle',
                          _attribution_stack: 'Skio Stack',
                          _dynamicBoxIndex: bundleIndex,
                          _dynamicBoxId: this.dynamicBoxId,
                          _bundleSellingPlanId: null,
                          _stackParentId: this.stackParentId,
                          _stackParentTitle: this.stackParentTitle,
                          _is_stack: true,
                          _bundle_session_id: bundleSessionId,
                          _internal_id: this.dynamicBoxId,
                          _is_stack_child: true
                        }
                      });
                    } else {
                      console.error('variant not available', variant?.title);
                    }
                  }
              
                  // parent last
                  items.push({
                    id: this.variantId,
                    quantity: 1,
                    selling_plan: null,
                    properties: {
                      _attribution: 'Skio Dynamic Product Bundle',
                      _attribution_stack: 'Skio Stack',
                      _bundleSellingPlanId: null,
                      _stackParentId: this.stackParentId,
                      _stackParentTitle: this.stackParentTitle,
                      _is_stack: true,
                      _bundle_session_id: bundleSessionId,
                      _internal_id: this.dynamicBoxId,
                      _is_stack_parent: true
                    }
                  });

              
                  if (this.discountCode && this.discountCode !== '') {
                    window.Rebuy.SmartCart.skip_open = false;
                    await this._applyDiscount(this.discountCode);
                    await window.Rebuy.SmartCart.applyDiscount(this.discountCode);
                    console.log('window.Rebuy.SmartCart', window.Rebuy.SmartCart);
                  }
                  await this._addItems(items);

                } else {
                  items.push({ id: this.variantId, quantity: 1 });
              
                  if (this.discountCode && this.discountCode !== '') {
                    window.Rebuy.SmartCart.skip_open = false;
                    await this._applyDiscount(this.discountCode);
                    await window.Rebuy.SmartCart.applyDiscount(this.discountCode);
                  }
                  await this._addItems(items);

                }
            
              },
              
            async _addItems(items) {
              const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items })
              });
            
              const data = await res.json().catch(() => ({}));

              if (!res.ok || data?.status === 422) {
                console.error('Add to cart failed', data);
                throw new Error(data?.description || 'Add to cart failed');
              }
            
              return data;
            },
            
            async _applyDiscount(code) {
              await fetch(`/discount/${encodeURIComponent(code)}`, { method: 'GET' });
              await fetch('/cart.js', 
                { method: 'GET' }).then(() =>{
                });
            },

        }));
    };